import { StrictMode } from 'react';
import * as Sentry from '@sentry/react';
import ReactDOM from 'react-dom/client';
import { initializeLaunchDarkly } from 'ui';
import { initializeHoneyCombTelemetry } from '@shared/libs/honeycomb/telemetry.ts';
import { enableMockServiceWorker } from '@shared/libs/msw';
import { enableProLicenseMUI } from '@shared/libs/MUI/index.ts';
import { initializeSentry } from '@shared/libs/sentry';
import { App } from './App.tsx';

initializeSentry();
initializeHoneyCombTelemetry();
enableMockServiceWorker();
enableProLicenseMUI();

const LDProvider = await initializeLaunchDarkly(
  import.meta.env.VITE_APP_LAUNCHDARKLY_ID,
);

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <StrictMode>
    <LDProvider>
      <Sentry.ErrorBoundary onError={(e) => Sentry.captureException(e)}>
        <App />
      </Sentry.ErrorBoundary>
    </LDProvider>
  </StrictMode>,
);
